<div class="form-panel">
  <form [formGroup]="taskForm" (ngSubmit)="onFormSubmit(taskForm.value)">
    <div class="step-wrapper step-1" *ngIf="stage == 0" formGroupName="step0">
      <app-task-step-config
        [formGroup]="step0Group"
        [workspaceList]="workspaceList"
        [reportList]="reportList"
        [pageList]="pageList"
        (onWorkspaceChange)="onWorkspaceChange($event)"
        (onReportChange)="onReportChange($event)"
        (onRefreshWorkspaceClick)="onRefreshWorkspaceClick()"
        (onPageAdd)="addPageAbove($event)"
        (onPageEdit)="updatePageAbove($event)"
        (onPageDelete)="deletePageAbove($event)"
      ></app-task-step-config>
      <div *ngIf="stageError" class="alert alert-danger">{{ stageError }}</div>
      <div
        *ngIf="step0Group.invalid && attemptedToSubmitInvalid && !stageError"
        class="alert alert-danger"
        i18n="generic form validation error message|A generic message to show to the user when some generic and unspecified input is invalid or empty@@genericInvalidFormMessage"
      >Please fill the form inputs correctly</div>
      <div class="form-group actions">
        <button
          *ngIf="showBackButtonFirstStage" type="button" class="btn btn-default" (click)="onBackClick($event)"
          i18n="Go Back@@goBack">Back</button>
        <button
          type="button"
          class="btn btn-success"
          (click)="onNextStageClick()"
          i18n="generic next button label|Generic message shown in forms where there are multiple steps and there is at least one step after the current one@@genericNextStepButtonLabel"
        >Next</button>
      </div>
    </div><div class="step-wrapper step-1" *ngIf="stage == 1" formGroupName="step1">
      <app-task-step-data
        [formGroup]="step1Group"
        [pageList]="pageList"
        [workspaceId]="task.PBIWorkspaceId"
        [reportId]="task.PBIReportId"
        (onPageAdd)="addObjectAbove($event)"
        (onPageDelete)="deleteObjectAbove($event)"
      ></app-task-step-data>
      <div *ngIf="stageError" class="alert alert-danger">{{ stageError }}</div>
      <div
        *ngIf="step1Group.invalid && attemptedToSubmitInvalid && !stageError"
        class="alert alert-danger"
        i18n="generic form validation error message|A generic message to show to the user when some generic and unspecified input is invalid or empty@@genericInvalidFormMessage"
      >Please fill the form inputs correctly</div>
      <div class="form-group actions">
        <button
          type="button"
          class="btn btn-default"
          (click)="onPreviousStageClick()"
          i18n="generic previous button label|Generic message shown in forms where there are multiple steps and there is at least one step preceding the current one@@genericPreviousStepButtonLabel"
        >Previous</button>
        <button
          type="button"
          class="btn btn-success"
          (click)="onNextStageClick()"
          i18n="generic next button label|Generic message shown in forms where there are multiple steps and there is at least one step after the current one@@genericNextStepButtonLabel"
        >Next</button>
      </div>
    </div>
    <div class="loading-step" *ngIf="stage == 2 && isLoadingContacts">
      <i class="fa fa-circle-o-notch fa-spin fa-5x"></i>
    </div>
    <div class="step-wrapper step-2" *ngIf="stage == 2 && !isLoadingContacts">
      <app-task-step-delivery
        [task]="task"
        [contacts]="contacts"
        [formGroup]="step2Group"
        [availableTags]="availableTags"
        (addDelivery)="addDeliveryAbove($event)"
        (updateDelivery)="updateDeliveryAbove($event)"
        (deleteDelivery)="deleteDeliveryAbove($event)"
      ></app-task-step-delivery>
      <div *ngIf="stageError" class="alert alert-danger">{{ stageError }}</div>
      <div
        *ngIf="step2Group.invalid && attemptedToSubmitInvalid && !stageError"
        class="alert alert-danger"
        i18n="generic form validation error message|A generic message to show to the user when some generic and unspecified input is invalid or empty@@genericInvalidFormMessage"
      >Please fill the form inputs correctly</div>
      <div class="form-group actions">
        <button
        type="button"
        class="btn btn-default"
        (click)="onPreviousStageClick()"
        i18n="generic previous button label|Generic message shown in forms where there are multiple steps and there is at least one step preceding the current one@@genericPreviousStepButtonLabel"
      >Previous</button>
        <button
        type="button"
        class="btn btn-success"
        (click)="onNextStageClick()"
        i18n="generic next button label|Generic message shown in forms where there are multiple steps and there is at least one step after the current one@@genericNextStepButtonLabel"
      >Next</button>
      </div>
    </div>
    <div class="step-wrapper step-3" *ngIf="stage == 3">
      <app-task-step-schedule
        [formGroup]="step3Group"
        (addSchedule)="addScheduleAbove($event)"
        (updateSchedule)="updateScheduleAbove($event)"
        (deleteSchedule)="deleteScheduleAbove($event)"
      ></app-task-step-schedule>
      <div *ngIf="stageError" class="alert alert-danger">{{ stageError }}</div>
      <div
        *ngIf="step3Group.invalid && attemptedToSubmitInvalid && !stageError"
        class="alert alert-danger"
        i18n="generic form validation error message|A generic message to show to the user when some generic and unspecified input is invalid or empty@@genericInvalidFormMessage"
      >Please fill the form inputs correctly</div>
      <div class="form-group actions">
        <button
          type="button"
          class="btn btn-default"
          (click)="onPreviousStageClick()"
          i18n="generic previous button label|Generic message shown in forms where there are multiple steps and there is at least one step preceding the current one@@genericPreviousStepButtonLabel"
        >Previous</button>
        <button
          type="button"
          class="btn btn-success"
          (click)="onNextStageClick()"
          i18n="generic next button label|Generic message shown in forms where there are multiple steps and there is at least one step after the current one@@genericNextStepButtonLabel"
        >Next</button>
      </div>
    </div>
    <div class="step-wrapper step-4" *ngIf="stage == 4 && !isSavingTask">
      <app-task-revision
      [contacts]="contacts"
      [task]="task"
      ></app-task-revision>
      <div class="form-group actions" *ngIf="startedAtEnd">
        <button type="button" class="btn btn-default" (click)="onBackClick($event)" *ngIf="startedAtEnd">Back</button>
        <button type="button" class="btn btn-success" (click)="onFirstStageClick()">Edit</button>
      </div>
      <div class="form-group actions" *ngIf="!startedAtEnd">
        <button
          type="button"
          class="btn btn-default"
          (click)="onPreviousStageClick()"
          i18n="generic previous button label|Generic message shown in forms where there are multiple steps and there is at least one step preceding the current one@@genericPreviousStepButtonLabel"
        >Previous</button>
        <input
          type="submit"
          role="button"
          class="btn btn-success"
          i18n-value="generic button label to save or submit|A generic button label to save or submit a form, sending the changes to the server@@genericSaveButton"
          value="Save"
        />
      </div>
      <div *ngIf="isStageErrorString" class="alert alert-danger">{{ stageError }}</div>
      <ul *ngIf="isStageErrorList" class="alert alert-danger">
        <li class="strong" i18n="error list preceding text|The text that precedes one or multiple errors that happened while trying to create a new task at the last step of the task form@@errorListPrefixTaskSubmit">There were errors while trying to submit the task:</li>
        <li *ngFor="let error of stageError"> - {{ error }}</li>
      </ul>
    </div>
    <div class="step-4 loading-step" *ngIf="stage === 4 && isSavingTask">
      <i class="fa fa-circle-o-notch fa-spin fa-5x"></i>
    </div>
  </form>
</div>
